import styled from 'styled-components';

export const Title = styled.span`
  font-family: Graphik;
  display: block;
  color: #222222;
  letter-spacing: 0;
  font-weight: 500;
  font-size: 32px;
  line-height: 38px;
  white-space: pre-wrap;
  margin-bottom: 32px;
`;

export const Container = styled.div`
  margin-bottom: 64px;
`;
